import { RouteObject, useParams } from "react-router-dom";
import { InstitutionSettings } from "./InstitutionSettings";

export const INSTITUTION_SETTINGS_ROUTES: RouteObject[] = [
  {
    children: [
      {
        index: true,
        async lazy() {
          return {
            element: <InstitutionSettings />,
          };
        },
      },
      {
        path: ":category",
        async lazy() {
          return {
            Component() {
              const { category } = useParams<{ category: string }>();
              return <InstitutionSettings initialCategory={category} />;
            },
          };
        },
      },
      {
        path: "categories/:category/groups/:group/subgroups",
        async lazy() {
          const { SettingsSubGroupPanel } = await import("./SettingsSubGroupPanel");
          return {
            Component() {
              const { category, group } = useParams<{
                category: string;
                group: string;
              }>();
              if (!category || !group) return null;
              return <SettingsSubGroupPanel category={category} group={group} />;
            },
          };
        },
      },
    ],
  },
];
